export const APP_NAME = 'OnlyCoach';

export const ROUTES = {
  home: (tenant: string) => `/${tenant}`,
  login: (tenant: string) => `/${tenant}/login`,
  authCallback: (tenant: string) => `/${tenant}/auth/callback`,
  onboarding: (tenant: string) => `/${tenant}/onboarding`,
  profile: (tenant: string) => `/${tenant}/profile`,
  settings: (tenant: string) => `/${tenant}/settings`,
  messages: (tenant: string) => `/${tenant}/messages`,
  coach: {
    dashboard: (tenant: string) => `/${tenant}/coach`,
    users: (tenant: string) => `/${tenant}/coach/users`,
    userDetail: (tenant: string, userId: string) => `/${tenant}/coach/users/${userId}`,
    cohorts: (tenant: string) => `/${tenant}/coach/cohorts`,
    cohortDetail: (tenant: string, cohortId: string) => `/${tenant}/coach/cohorts/${cohortId}`,
    createForm: (tenant: string, cohortId: string) => `/${tenant}/coach/cohorts/${cohortId}/form/new`,
    editForm: (tenant: string, cohortId: string, signalId: string) => `/${tenant}/coach/cohorts/${cohortId}/form/${signalId}`,
    groups: (tenant: string) => `/${tenant}/coach/groups`,
    inbox: (tenant: string) => `/${tenant}/coach/inbox`,
  },
};
